import API from '@/org-app/api';
import {
  createAuditAction,
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  getMobileLineItems: createGetAllAction(
    API.instance.getMobileLineItems,
    types.UPDATE_MOBILELINEITEMS_LIST,
    'messages.failedToGetMobileLineItems',
    true,
    (commit, res) => commit(types.UPDATE_MOBILELINEITEMS_TOTAL_COUNT, res.totalCount),
  ),
  getMobileLineItem: createGetOneAction(
    API.instance.getMobileLineItem,
    types.UPDATE_MOBILELINEITEM,
    'messages.failedToGetMobileLineItem',
  ),
  createMobileLineItems: createPostAction(
    API.instance.postMobileLineItems,
    types.SAVE_MOBILELINEITEMS,
    'messages.failedToCreateMobileLineItem',
  ),
  updateMobileLineItem: createPutAction(
    API.instance.putMobileLineItem,
    types.SAVE_MOBILELINEITEMS,
    'messages.failedToUpdateMobileLineItem',
  ),
  deleteMobileLineItem: createDeleteAction(
    API.instance.deleteMobileLineItem,
    types.DELETE_MOBILELINEITEM,
    'messages.failedToDeleteMobileLineItem',
  ),
  getMobileLineItemAudit: createAuditAction(
    API.instance.getMobileLineItemAudit,
    'messages.failedToGetMobileLineItemAudit',
  ),
};
